import { colors } from '../../colors';
var pagination = {
  activeColor: colors.nvaTeal,
  defaultColor: colors.nvaBlack
};
export default pagination;